class exports.ResponsiveNavDropper

    attach: (elem, button = 'More', fudge = 0) ->
        # fudge needs to be slightly larger here
        fudge += 7
        # attach the responsive-dropper menu, hidden
        @_addMoreMenu(elem, button)

        # immediately check size
        @_handleResize(elem, fudge)

        # attach listener for window resize
        $(window).resize () =>
            @_handleResize(elem, fudge)


    ###
    Handle checking the size of the element and resizing accordingly
    ###
    _handleResize: (elem, fudge) =>
        diff = @_checkSize(elem, fudge)

        if diff > 0
            @_resizeDown(elem, diff)
        else
            @_resizeUp(elem, diff)


    ###
    Adds the "More" menu, initially hidden.
    This is where menu elements that don't fit will be moved to
    ###
    _addMoreMenu: (elem, button) ->
        # if no drop menu, add it.
        if elem.find('.responsive-dropper').length is 0
            elem.append('
                <li class="dropdown nav-dropper responsive-dropper hide">
                    <a class="dropdown-toggle ignore-nav-handling" data-toggle="dropdown">
                        ' + button + '
                        <b class="caret"></b>
                    </a>
                    <ul class="dropdown-menu pull-right">
                    </ul>
                </li>
            ')


    ###
    Checks the size of element against the window size (including our fudge factor)
    and decides how much it should be allowed to adjust to fill space not taken up by siblings
    ###
    _checkSize: (elem, fudge) ->

        sumW = @_sumWidth(elem.children('li:not(.hide)'))
        sibW = @_sumWidth(elem.siblings('ul'))

        docW = $(window).width()
        diff = (sumW + sibW) - (docW - fudge)

        return diff


    ###
    Handles shrinking menu items into the "More" dropdown
    ###
    _resizeDown: (elem, size_to_account) ->
        lis = elem.children('li:not(.responsive-dropper)')

        elem.find('.responsive-dropper').removeClass 'hide'

        # calculate number of elements to move into drop menu.
        tail = lis.length
        repaired_width = 0
        start_at = null

        # Iterate over the pages in reverse,
        # figure out how many need removed.
        for num in [(tail - 1)..0]
            subEl = lis.eq(num)
            repaired_width += subEl.outerWidth()

            # If this is a nested drop down split the nested pages
            # into individual navigation with the title "Group - Page Name"
            nestedLis = $.makeArray subEl.find('li')
            if nestedLis.length isnt 0
                groupTitle = subEl.find('.ignore-nav-handling').text().trim()

                for page in nestedLis.reverse()
                    page = $(page)

                    # generate new page title
                    pageTitle = page.text().trim()
                    newTitle = groupTitle.concat ' - ', pageTitle
                    page.find('.nested-text').html(newTitle)

                    # store the navigations width, designating this a nested page
                    page.data('nav-dropper-width', subEl.outerWidth())
                    page.data('page-title', pageTitle)
                    page.data('group-title', groupTitle)

                    #  and prepend page
                    elem.find('.responsive-dropper').find('ul').prepend(page)
            else
                # Otherwise store the nav width and prepend the page
                subEl.data('responsive-dropper-width', subEl.outerWidth())
                elem.find('.responsive-dropper').find('ul').prepend(subEl)

            # If we have enough width stop
            if repaired_width >= size_to_account
                break

        # remove the group drop down elements from the 'More' list
        elem.find('.responsive-dropper .nav-dropper').remove()


    ###
    Handles moving elements back out of the 'More' dropdown, if the
    window size has grown larger / has more room now
    ###
    _resizeUp: (elem, size_to_account) ->
        lis = elem.find('.responsive-dropper .dropdown-menu').children('li')

        size_to_account = Math.abs(size_to_account)

        repaired_width = 0
        handledNavIndexes = []

        for num in [0..(lis.length - 1)]
            subEl = lis.eq(num)

            # This index may already have been handled
            if num in handledNavIndexes
                continue

            w = subEl.data('responsive-dropper-width')
            navW = subEl.data('nav-dropper-width')

            # If this is a nested page, find sibling pages
            # And create new drop down
            if navW?
                repaired_width += navW

                if repaired_width < size_to_account
                    groupTitle = subEl.data('group-title')

                    # Open group html
                    groupHtml = "<li class='dropdown nav-dropper nested-navigation'>
                        <a class='dropdown-toggle ignore-nav-handling' data-toggle='dropdown'>" + groupTitle +
                            "<b class='caret'></b>
                        </a>
                        <ul class='dropdown-menu pull-right'>
                        </ul>
                    </li>"
                    groupHtml = $(groupHtml)
                    group = elem.find('.responsive-dropper').before(groupHtml)

                    # Find and append sibling pages
                    siblings = _.filter lis, (li) =>
                        return $(li).data('group-title') is groupTitle

                    # Update page titles and store index of handled page
                    for li in siblings
                        handledNavIndexes.push(lis.index li)
                        $(li).find('.nested-text').text($(li).data('page-title'))

                    # Append to nav bar
                    # Reverse corrects the order
                    groupHtml.find('ul.dropdown-menu').append siblings
                else
                    break
            else
                if w?
                    repaired_width += w

                if repaired_width < size_to_account
                    elem.find('.responsive-dropper').before(subEl)
                else
                    break

        if lis.length is 0
            elem.find('.responsive-dropper').addClass 'hide'


    _sumWidth: (elem) ->
        w = 0

        elem.each () ->
            w += $(this).outerWidth()
        return w
